const MENUS_TO_ANALYZE = [
  'Produkter', 'Products', 
  'Kategorier', 'Categories',
  'CHRISTMAS TIME', 'Categories'
];
const SUPER_TOP_LEVEL = [
  'Produkter', 'Products'
];
const WEAK_TOP_LEVEL = [
  'Produkter', 'Products', 
  'Varumärke', 'Trademark', 'Brand',
  'Varumärken', 'Trademarks', 'Brands'
];
const DONT_USE_AS_TOP_LEVEL = [
  
];

const DRAW_GRAND_PARENTS = false;
const FIND_BUDDHA_RETRY_DELAY = 300;
const FIND_BUDDHA_RETRIES = 10;
const LIMIT_BUTTONS_TO_PAGEWIDTH = true;
const REDIRECT_FROM_COLLECTIONS_ALL = true;



function getAHref(aElement) {
  if(!aElement) {
    return null
  }
  const href = aElement.href.trim()
  if(!href) {
    return null
  }
  if(href == 'javascript:void(0);')
  {
    return null;
  }
  return href;
}

function listContainsTitle(list, title) {
  for(var i = 0; i < list.length; ++i){
    if(list[i].toLowerCase() === title.toLowerCase()){
      return true;
    }
  }
  return false;
}

function setArtificialTopLevel(topLevelItems){
  var collectiveTopLevel = null;
  for(var i = 0; i < topLevelItems.length; ++i){
    if(topLevelItems[i].collectiveTopLevel) {
      collectiveTopLevel = topLevelItems[i];
    }
  }
  if(!collectiveTopLevel) {
    return topLevelItems;
  }
  newList = [];
  for(var i = 0; i < topLevelItems.length; ++i){
    if(topLevelItems[i] != collectiveTopLevel && !collectiveTopLevel.children.includes(topLevelItems[i])) {
      newList.push(topLevelItems[i]);
      topLevelItems[i].parent = collectiveTopLevel;
    }
  }
  collectiveTopLevel.children = newList.concat(collectiveTopLevel.children);
  return [collectiveTopLevel];
}

function getMenuObject(topLiElement, parent = null) {
  const aElement = topLiElement.querySelector(':scope > a');
  const titleElement = aElement.querySelector(':scope > span.mm-title');
  
  const object = {}
  object.parent = parent;
  object.title = titleElement.textContent.trim()
  object.href = getAHref(aElement);
  object.liElement = topLiElement
  object.topLevelCandidate = !listContainsTitle(DONT_USE_AS_TOP_LEVEL, object.title);
  object.weakTopLevel = listContainsTitle(WEAK_TOP_LEVEL, object.title);
  object.collectiveTopLevel = listContainsTitle(SUPER_TOP_LEVEL, object.title);
  
  return object;
}

function getSubMenuTree(topLiElement, parent = null) {
  const object = getMenuObject(topLiElement, parent);
  object.children = [];
  
  const topLevelLis = topLiElement.querySelectorAll(":scope > ul.mm-submenu > li");
  topLevelLis.forEach(liElement => {
    object.children.push(getSubMenuTree(liElement, object))
  });
  
  return object;
}

function getMegaMenuTree() {
  const usedItems = []
  const topLevelLis = document.querySelectorAll("#menu-drawer li.buddha-menu-item");
  topLevelLis.forEach(liElement => {
    const object = getMenuObject(liElement);
    MENUS_TO_ANALYZE.forEach(x => {
      if(x.toLowerCase() == object.title.toLowerCase()){
        usedItems.push(liElement);
      }
    });
  });
  
  const topLevelItems = []
  usedItems.forEach(liElement => {
    const object = getSubMenuTree(liElement);
    topLevelItems.push(object);
  });
  return setArtificialTopLevel(topLevelItems);
}

function standardiseLink(link) {
  const removeBeginnings = ['http://', 'https://'];
  for(var i = 0; i < removeBeginnings.length; ++i)
  {
    const beginning = removeBeginnings[i];
    if(link.startsWith(beginning)){
      link = link.slice(beginning.length);
      break;
    }
  }
  link = link.split('/').slice(1).join('/');
  return link;
}
function linkMatchesUrl(link) {
  if(!link) {
    return false;
  }
  const pathNameStandardised = standardiseLink(window.location.pathname)
  if(link == "") {
    return pathNameStandardised == "";
  }

  const linkStandardised = standardiseLink(link);
  return pathNameStandardised == linkStandardised;
}

function getCurrentPositionInTree(megaMenuTreeRoot) {
  if(linkMatchesUrl(megaMenuTreeRoot.href)) {
    const positionObject = {}
    return megaMenuTreeRoot;
  }
  
  for(var i = 0; i < megaMenuTreeRoot.children.length; ++i) {
    const foundPosition = getCurrentPositionInTree(megaMenuTreeRoot.children[i]);
    if(foundPosition) {
      return foundPosition;
    }
  }

  return null;
}

function getCurrentPositionInTreeList(megaMenuTree){
  for(var i = 0; i < megaMenuTree.length; ++i) {
    const currentRoot = megaMenuTree[i];
    const result = getCurrentPositionInTree(currentRoot);
    if(result){
      return result;
    }
  }
  return null;
}

function objectToHTMLButton(whatToDraw, object) {
  var aClasses = 'collection-navigation-button-button';
  var liClasses = ''
  var href;
  if(object == whatToDraw.activeObject) {
    aClasses += ' current-page-button-a';
    liClasses += 'current-page-button-li';
    href = object.parent.href;
  } else {
    if(object == whatToDraw.semiActiveObject) {
      aClasses += ' current-parent-page-button-a';
      liClasses += 'current-parent-page-button-li';
    }
    href = object.href;
  }
  if(!href){
    href = '#';
  }
  
  return '<li = "' + liClasses  + '"><a class="' + aClasses + '" href="' + href + '">' + object.title + '</a></li>';
}

function objectsToHTMLButtons(whatToDraw, objects, customClasses = '') {
  if(objects.length == 0) {
    return '';
  }
  
  var classes = "collection-navigation-button-list";
  if(LIMIT_BUTTONS_TO_PAGEWIDTH){
    classes += " page-width"
  }
  if(customClasses)
  {
    classes += ' ' + customClasses;
  }
  return '<ul class="' + classes + '">' + objects.map(x => objectToHTMLButton(whatToDraw, x)).join("\n") + '</ul>';
}

function getWhatToDraw(positionObject) {
  if(!positionObject.topLevelCandidate)
  {
    return null;
  }
  var grandParent = null;
  var parent;
  var siblings;
  var children;
  var semiActiveObject = null;
  const activeObject = positionObject;
  
  if(positionObject.parent && positionObject.parent.topLevelCandidate) {
    var currentLevelObject;
    if(positionObject.parent.children.some(x => x.children.length > 0) || (positionObject.parent.parent && positionObject.parent.parent.weakTopLevel)) {
      currentLevelObject = positionObject;
      children = positionObject.children.slice();
    } else {
      currentLevelObject = positionObject.parent;
      semiActiveObject = currentLevelObject;
      children = currentLevelObject.children.slice();
    }
    if(currentLevelObject.parent && currentLevelObject.parent.topLevelCandidate) {
      parent = currentLevelObject.parent;
      siblings = currentLevelObject.parent.children.filter(child => child != positionObject.object);
    } else {
      parent = currentLevelObject;
      siblings = children;
      children = [];
    }

    if(parent.weakTopLevel && positionObject.children.length > 0) {
      grandParent = parent;
      parent = positionObject;
      siblings = positionObject.children.slice();
      children = [];
    } else if(parent && parent.parent) {
      grandParent = parent.parent;
    }
  } else {
    parent = positionObject;
    siblings = positionObject.children.slice();
    children = [];
  }

  const whatToDraw = {}
  whatToDraw.grandParent = grandParent;
  whatToDraw.parent = parent;
  whatToDraw.siblings = siblings;
  whatToDraw.children = children;
  whatToDraw.activeObject = activeObject;
  whatToDraw.semiActiveObject = semiActiveObject;
  return whatToDraw;
}

function drawDrawlist(anchor, drawList){
  if(!drawList){
    anchor.style.cssText = "display: none";
    return;
  }
  if(drawList.siblings.length == 0 && drawList.children.length == 0 && !drawList.grandParent) {
    anchor.style.cssText = "display: none";
    return;
  }
  
  var htmlCode = "";
  var parentExtraClasses = "";
  if(DRAW_GRAND_PARENTS && drawList.grandParent) {
    if(drawList.grandParent.href) {
      var classes = 'collection-navigation-buttons-heading grand-parent page-width';
      if(drawList.grandParent.weakTopLevel){
        classes += ' weak-parent';
      }
      htmlCode += '<h3 class="'+ classes + '"><a href="' + drawList.grandParent.href + '">' + drawList.grandParent.title + '</a></h3>' + '\n'; 
    } else if(!drawList.grandParent.weakTopLevel) {
      htmlCode += '<h3 class="collection-navigation-buttons-heading grand-parent page-width">' + drawList.grandParent.title + '</h3>' + '\n'; 
    }
    if(!drawList.grandParent.weakTopLevel)
    {
      parentExtraClasses = " child-parent";
    }
  }

  if(drawList.siblings.length > 0 || drawList.children.length > 0) {
    if(drawList.parent.href) {
      htmlCode += '<h3 class="collection-navigation-buttons-heading' + parentExtraClasses + ' page-width"><a href="' + drawList.parent.href + '">' + drawList.parent.title + '</a></h3>' + '\n'; 
    } else {
      htmlCode += '<h3 class="collection-navigation-buttons-heading' + parentExtraClasses + ' page-width">' + drawList.parent.title + '</h3>' + '\n'; 
    }
    htmlCode += objectsToHTMLButtons(drawList, drawList.siblings, 'siblings') + '\n';
    if(drawList.siblings.length > 0 && drawList.children.length > 0)
    {
      htmlCode += '<div class="collection-navigation-button-divisor"></div>' + '\n';
    }
    htmlCode += objectsToHTMLButtons(drawList, drawList.children, 'children') + '\n';
  }
  
  anchor.style.cssText = "";
  anchor.innerHTML = htmlCode;
}

function addButtonsFromTree(anchor, positionObject) {
  if(!positionObject) {
    return null;
  }

  const drawList = getWhatToDraw(positionObject);
  drawDrawlist(anchor, drawList);
}

function addButtonsMain(megaMenuTree) {
  const anchors = document.querySelectorAll('.collection-navigation-buttons-anchor');
  anchors.forEach(anchor => {
    addButtonsFromTree(anchor, megaMenuTree)
  });
}

function buddhaMenuHasLoaded() {
  if(document.querySelector(".buddha-menu-item")){
    return true;
  } else {
    return false;
  }
}

function displayNoProductsFound() {
  const wrapper = document.querySelector('#ProductGridContainer .collection--empty .title-wrapper');
  const element = document.querySelector('#ProductGridContainer .collection--empty .title-wrapper .title');
  if(!wrapper || ! element) {
    return;
  }
  wrapper.style.height="auto";
  element.style.display="block";
  if(Shopify.locale == 'en') {
    element.innerHTML = "No products found";
  } else {
    element.innerHTML = "Inga produkter hittades";
  }
}

function hideProductListingElementsIfEmpty() {
  const anyDescription = document.querySelector('.collection-hero__description');
  var html = '';
  if(!anyDescription || anyDescription.children.length === 0){
    html += '.collection-hero__title,';
  }
  html += `
  .product-count,
  .facet-filters,
  .mobile-facets__wrapper {
    display: none!important;
  }
  `;
  const style = document.createElement('style');
  style.innerHTML = html;
  document.head.appendChild(style);
}

function fixEmptyCollectionPage(positionObject){
  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) {
    return;
  }

  if(productGrid.nodeName === 'UL'){
    return;
  }

  if(productGrid.nodeName !== 'DIV') {
    return;
  }

  
  if(positionObject.children.length > 0) {
    hideProductListingElementsIfEmpty();
  } else {
    displayNoProductsFound();
  }
}

/* opening menus does not work because the buddha script crashes and has no way of remembering what items are open when the menu is not open.
function openMenusRecursively(positionObject) {
  const parent = positionObject.parent;
  if(!parent){
    const expandButton = positionObject.liElement.querySelector(':scope > a > .toggle-menu-btn');
    expandButton.click();
    return;
  }

  const expandButton = parent.liElement.querySelector(':scope > a > .toggle-menu-btn > .mm-arrow-icon');
  openMenusRecursively(parent);
  expandButton.click();
}
function openMenus(positionObject){
  if(!positionObject){
    return;
  }
  menuOpener = document.querySelector('.header__icon.header__icon--menu');
  if(!menuOpener) {
    return;
  }
  menuOpener.click();
  openMenusRecursively(positionObject);
}
*/

function redirectFromCollectionsAll(megaMenuTree, positionObject){
  if(!REDIRECT_FROM_COLLECTIONS_ALL){
    return;
  }
  if(!linkMatchesUrl('/collections/all')) {
    return;
  }
  if(positionObject && linkMatchesUrl(positionObject.href))
  {
    return;
  }
  if(megaMenuTree.length == 0){
    return;
  }

  window.location.replace(megaMenuTree[0].href);
}

function menuImprovementsMain(){
  const megaMenuTree = getMegaMenuTree();
  const positionObject = getCurrentPositionInTreeList(megaMenuTree);
  redirectFromCollectionsAll(megaMenuTree, positionObject);
  addButtonsMain(positionObject);
  fixEmptyCollectionPage(positionObject);
  //openMenus(positionObject);
}

function neutraliseAnchors(){
  const anchors = document.querySelectorAll('.collection-navigation-buttons-anchor');
  anchors.forEach(anchor => {
    anchor.style.cssText = 'display: none';
  });
}

function tryDrawingMenu(retriesLeft = null) {
  if(retriesLeft == null){
    retriesLeft = FIND_BUDDHA_RETRIES;
  }
  
  if(retriesLeft <= 0) {
    neutraliseAnchors();
    return;
  }
  
  if(buddhaMenuHasLoaded()) {
    menuImprovementsMain();
    return;
  } 
  
  setTimeout(function() {
    tryDrawingMenu(retriesLeft - 1);
  }, FIND_BUDDHA_RETRY_DELAY);
}



document.addEventListener('DOMContentLoaded', function(event) {
  tryDrawingMenu();
});



/*
if(getCookie(CookieName)) {
  document.addEventListener('DOMContentLoaded', function(event) {
    tryDrawingMenu();
  });
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000)); 
  const expires = "expires=" + d.toUTCString();

  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
function getCookie(name) {
  const nameEq = name + "=";
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(nameEq) === 0) {
      return c.substring(nameEq.length, c.length);
    }
  }
  return null;
}

const ParameterName = "previewbreadcrumbs";
const CookieName = "previewbreadcrumbs";
const urlParams = new URLSearchParams(window.location.search);
if(urlParams.get(ParameterName) == "true"){
  setCookie(CookieName, "true", 30);
}
*/